import React from "react";
import { ConditionCard, ConditionCardProps } from "./ConditionCard";
import { useEmployeeRecordAttributeSuggestions } from "../../hooks/useEmployeeRecordCache";

export const ConditionCardWithEmployeeRecords: React.FC<
  Omit<
    ConditionCardProps,
    | "getSuggestionsFunc"
    | "getAvailableAttributePathsFunc"
    | "getAttributeConfigFunc"
  >
> = (props) => {
  const { getSuggestions, getAvailableAttributePaths, getAttributeConfig } =
    useEmployeeRecordAttributeSuggestions();

  return (
    <ConditionCard
      {...props}
      getSuggestionsFunc={getSuggestions}
      getAvailableAttributePathsFunc={getAvailableAttributePaths}
      getAttributeConfigFunc={getAttributeConfig}
    />
  );
};
